import { configure, makeAutoObservable } from 'mobx';
import { makePersistable, isHydrated } from 'mobx-persist-store';

import defaultSettings from '../../settings.json';
import { getUserAvatarUrl, getUserInfo } from '@/api/modules/user';
import { setTokenToLocalStorage } from '@/utils/token';

export interface UserInfo {
  uuid?: string;
  isLogin?: boolean;
  nickname?: string;
  avatar?: string;
  avatar_color?: string;
  job?: string;
  organization?: string;
  location?: string;
  email?: string;
  permissions: Record<string, string[]>;
}
export interface GlobalState {
  settings?: typeof defaultSettings;
  userInfo?: UserInfo;
  userLoading?: boolean;
}

configure({
  enforceActions: 'never', // 默认是observed、只能在action函数中修改、设置never、可以在任何函数中进行修改
});

class UserStore {
  settings =
    JSON.parse(localStorage.getItem('LoginStore') || '{}').userInfo?.settings
      ?.themeColor ?? defaultSettings;
  userInfo: UserInfo = { permissions: {} };
  userLoading = false;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
    makePersistable(this, {
      name: 'UserStore', // 保存的name，用于在storage中的名称标识，只要不和storage中其他名称重复就可以
      properties: ['userInfo', 'settings'], // 要保存的字段，这些字段会被保存在name对应的storage中，注意：不写在这里面的字段将不会被保存，刷新页面也将丢失：get字段例外。get数据会在数据返回后再自动计算
      storage: window.localStorage, // 保存的位置：看自己的业务情况选择，可以是localStorage，sessionStorage
    });
  }

  // 注意这个字段的使用：在页面useEffect的时候，如果你没有添加依赖数组（初始化执行），那么你可能拿不到computed计算的数据（原因是这时候还没有persist结束）
  // 这个属性还是比较重要的，因为它可以在页面上做判断，当页面load完成，get数据计算完成之后，isHydrated会置为true
  get isHydrated() {
    return isHydrated(this);
  }

  reset() {
    this.settings = defaultSettings;
    this.userInfo = { permissions: {} };
  }

  setLoading(v) {
    this.userLoading = v;
  }

  async getUserInfo() {
    const search: any = new URLSearchParams(location.search);
    const token = search.get('token') ?? localStorage.getItem('Token');
    const res: any = await getUserInfo();
    console.log('res=================>', res);

    if (res?.code === 0) {
      this.userInfo = {
        ...res.data,
        avatar: res.data.avatar
          ? (await getUserAvatarUrl(res.data.avatar)).data?.url
          : null,
      };
      setTokenToLocalStorage(token);
      if (search.get('token')) {
        location.replace('/matrix');
      }
    } else {
      this.userInfo = res.data;
      location.replace('/login');
    }
  }

  setUserInfo(value) {
    this.userInfo = value;
  }

  updateSetting(v) {
    this.settings = {
      ...this.settings,
      ...v,
    };
  }
}

const userStore = new UserStore();

export default userStore;
